<template>
  <div class="detail">
    <TopBack :title="$t('lang.menu.Responsible')" style="margin-top: 66px;"/>
    <div class="detailContainer">
      <div v-for="(item, index) in responsibleList" :key="index" :class="item.class"
           v-html="treatHtml(item.content)"></div>
      <div class="bottomLogo">
        <img :src="logo" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import logo from '@/assets/images/common/logo1.svg'

export default {
  name: 'Responsible',
  data () {
    return {
      logo,
      responsibleList: this.$t('lang.responsible')
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.responsibleList = this.$t('lang.responsible')
    }
  },
  components: {
    TopBack
  },
  methods: {
    treatHtml: function (str) {
      str = str.replace('www.pgebet.com', location.host)
      str = str.replace('app.', 'www.')
      return str
    }
  }
}
</script>

<style lang="less" scoped>
  .detail {
    height: 80vh;
    .detailContainer {
      height: 100%;
      overflow: auto;
      margin-top: 22px;
      padding: 0 16px;
      .t0 {
        font-size: 20px;
        line-height: 21px;
        color: #F6D9AA;
        font-weight: bold;
        margin: 20px 0;
      }
      .t1 {
        font-size: 18px;
        line-height: 21px;
        color: #F6D9AA;
        font-weight: bold;
        margin: 20px 0;
      }
      .t2 {
        font-size: 14px;
        line-height: 140%;
        color: #fff;
        margin-bottom: 12px;
      }
      .t3 {
        display: flex;
        font-size: 12px;
        line-height: 18px;
        color: #fff;
        i {
          margin-left: 10px;
        }
      }
      .bottomLogo {
        text-align: right;
        img {
          width: 40px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Responsible.vue